import { Button, Card, Choicebox, FormButtonRow, FormGroup, RadioGroup } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { useState } from 'react';
import type { OrderSuppliesEpisodeCategory } from '@common/interfaces/orderSuppliesEpisodeCategory';
import { supplyCategoriesByEpisodeCategory } from '@common/constants/supplyCategoriesByEpisodeCategory';
import { getSelectedLanguage } from '@frontend/translate';
import { episodeCategoryToRouteParam } from '../utils/orderSuppliesRouteUtils';

export function OrderSuppliesOverview() {
    const navigate = useNavigate();
    const translate = getSelectedLanguage();
    const [selectedEpisodeCategory, setSelectedEpisodeCategory] = useState<OrderSuppliesEpisodeCategory | ''>('');
    const [showError, setShowError] = useState(false);

    const availableEpisodeCategories = Object.keys(supplyCategoriesByEpisodeCategory) as OrderSuppliesEpisodeCategory[];

    const handleEpisodeCategoryChange = (selectedValue: OrderSuppliesEpisodeCategory) => {
        setSelectedEpisodeCategory(selectedValue);
        setShowError(false);
    };

    const handleNext = () => {
        if (!selectedEpisodeCategory) {
            setShowError(true);

            return;
        }

        const episodeCategoryRouteParam = episodeCategoryToRouteParam(selectedEpisodeCategory);
        navigate(`/materialenBestellen/${episodeCategoryRouteParam}`);
    };

    return (
        <Card>
            <Card.Header title={'Selecteer een zorgpad'}></Card.Header>
            <Card.Body>
                <FormGroup
                    hasErrors={showError}
                    isRequired={true}
                    layout="vertical"
                >
                    <RadioGroup
                        error={showError ? translate.validation.object_anyFilledIn : undefined}
                        layout="row"
                        onChange={(event) =>
                            handleEpisodeCategoryChange(event.target.value as OrderSuppliesEpisodeCategory)
                        }
                        value={selectedEpisodeCategory}
                    >
                        {availableEpisodeCategories.map((episodeCategory) => (
                            <Choicebox
                                flex={1}
                                key={episodeCategory}
                                label={
                                    translate.episodeCategoryEnum[
                                        episodeCategory as keyof typeof translate.episodeCategoryEnum
                                    ]
                                }
                                value={episodeCategory}
                            />
                        ))}
                    </RadioGroup>
                </FormGroup>

                <FormButtonRow>
                    <Button onClick={handleNext}>{translate.common.proceed}</Button>
                </FormButtonRow>
            </Card.Body>
        </Card>
    );
}
